// extracted by mini-css-extract-plugin
export default {"page":"Results_page__uQeha","head":"Results_head__TdiAw","title":"Results_title__tT-8A","muted":"Results_muted__VKBD0","searchWrap":"Results_searchWrap__KYwEr"};